module.exports = __webpack_public_path__ + "img/wandering-stars.fa5b5aff.png";